import { DialogContent, styled } from '@mui/material';

export const SpanWithPictureAction = styled('span')(() => ({
  margin: '0 0.4rem',
  cursor: 'pointer'
}));

export const DialogContentWithImgModalContent = styled(DialogContent)(() => ({
  padding: 'min(2vw, 20px) !important'
}));

export const ImgWithModalImg = styled('img')(() => ({
  maxWidth: '70vw'
}));
